import { __decorate, __extends, __metadata } from "tslib";
import { Dictionary } from "../Decorators";
import { ModelFieldInfo } from "../ModelFieldInfo";
import ValueObject from "../ValueObject";
var CriteriaBase = /** @class */ (function (_super) {
    __extends(CriteriaBase, _super);
    function CriteriaBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Extra information about lookup fields in this object.
         */
        _this.fieldInfo = {};
        return _this;
    }
    /**
     * Initialise the fieldInfo dictionary for the passed in properties.
     * This is only necessary if you need to bind to the ModelFieldInfo values.
     * You must also call this.makeObservable(); instead of using the @NeoModel decorator.
     */
    CriteriaBase.prototype.initialiseFieldInfo = function (fields) {
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var field = fields_1[_i];
            if (!this.fieldInfo[field]) {
                this.fieldInfo[field] = new ModelFieldInfo(this.meta[field].propertyInfo.readableName, "");
            }
        }
    };
    CriteriaBase.prototype.setModelFieldInfo = function (property, displayValue) {
        var propertyName = property.propertyName;
        var fieldInfo = this.fieldInfo[propertyName];
        if (!fieldInfo) {
            fieldInfo = new ModelFieldInfo(property.readableName, displayValue);
            this.fieldInfo[propertyName] = fieldInfo;
        }
        else {
            fieldInfo.valueString = displayValue;
        }
        return fieldInfo;
    };
    __decorate([
        Dictionary(ModelFieldInfo),
        __metadata("design:type", Object)
    ], CriteriaBase.prototype, "fieldInfo", void 0);
    return CriteriaBase;
}(ValueObject));
export { CriteriaBase };
